module.exports = __webpack_public_path__ + "static/media/Aged Cherry_.75in.6ee9ae3f.jpg";